import { defineComponent as _defineComponent } from 'vue'
import type { SpotlightModuleFragment } from '@/features/onboarded-home/types';

import NewTitleSpotlightModule from '@/features/onboarded-home/components/modules/spotlights/NewTitleSpotlightModule.vue';
import TrendingSpotlightModule from '@/features/onboarded-home/components/modules/spotlights/TrendingSpotlightModule.vue';
import TvstSpotlightModule from '@/features/onboarded-home/components/modules/spotlights/TvstSpotlightModule.vue';
import GoingViralSpotlightModule from '@/features/onboarded-home/components/modules/spotlights/GoingViralSpotlightModule.vue';

import { useModuleContextData } from '@/features/onboarded-home/tracking';
import { useProvideClickoutPlacement } from '@/helpers/composables/useProvideClickoutPlacement';

import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'SpotlightModulesLoader',
  props: {
    moduleData: null,
    globalPosition: null,
    localPosition: null
  },
  setup(__props: any) {

const props = __props as {
	moduleData: SpotlightModuleFragment;
	globalPosition: number;
	localPosition?: number;
};



const { provideLocalModuleSize, provideModuleContainerType } = useModuleContextData();

useProvideClickoutPlacement('spotlight');

const moduleComponents = computed(() =>
	props.moduleData.modules
		.map(moduleData => {
			if (moduleData == null) return null;

			switch (moduleData.__typename) {
				case 'HMSpotlightGoingViral':
					return { moduleData, component: GoingViralSpotlightModule };

				case 'HMSpotlightNewOnYourWatchlist':
				case 'HMSpotlightNewSimilarToLikedTitle':
				case 'HMSpotlightNewWithHighRatings':
					return { moduleData, component: NewTitleSpotlightModule };

				case 'HMSpotlightTrendingToday':
					return { moduleData, component: TrendingSpotlightModule };

				case 'HMSpotlightContinueWatching':
					return {
						moduleData,
						component: TvstSpotlightModule,
						moduleProps: { showHeading: true },
					};

				default:
					return null;
			}
		})
		.filter(m => m != null)
);

provideLocalModuleSize(() => moduleComponents.value.length);
provideModuleContainerType(() => props.moduleData.type);

return { __sfc: true,props, provideLocalModuleSize, provideModuleContainerType, moduleComponents }
}

})